// extracted by mini-css-extract-plugin
module.exports = {"search":"_17276","box":"_15251","icon":"_14995","input":"_18690","clear":"_4058","btn":"_18774"};